"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("@seneca/errors");
class UnauthorisedResponseError extends errors_1.ExtendableError {
    constructor({ method, url, correlationId }) {
        super(`Received unauthorised response from server for ${method} - ${url}`);
        this.correlationId = correlationId;
    }
}
exports.default = UnauthorisedResponseError;
